import { connectStaleableLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { memberInfoGuard } from 'guards/globalGuards'
import { showPasswordChangeFormActionCreator } from 'actions/settingsActions'
import AccountSettingsModule, {
  AccountSettingsModuleDispatchProps,
  AccountSettingsModuleStateProps,
} from 'components/features/pfm/AccountSettingsModule/AccountSettingsModule'
import { isMemberDataPresentSelector, memberInfoSelector } from 'selectors/globalSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { createSelector } from 'reselect'
import { settingsSelector } from 'selectors/settingsSelector'

const createMapStateToProps = () => createSelector(
  memberInfoSelector,
  settingsSelector,
  (member, { passwordChangeFormVisible }): AccountSettingsModuleStateProps => {
    if (!member) {
      throw createForgottenGuardError('AccountSettingsModuleContainer', 'memberInfoGuard')
    }
    const { first_name, last_name, email, birth_date } = member

    // TODO somewhen get rid of ! here
    return {
      firstName: first_name!,
      lastName: last_name!,
      email: email!,
      birthDate: birth_date!,
      passwordChangeFormVisible,
    }
  }
)

const mapDispatchToProps = {
  showPasswordChangeForm: showPasswordChangeFormActionCreator,
}

const guards: Guards<{}> = [
  memberInfoGuard,
]

export default connectStaleableLoadable<
  AccountSettingsModuleStateProps, AccountSettingsModuleDispatchProps
>(guards, isMemberDataPresentSelector)(createMapStateToProps, mapDispatchToProps)(AccountSettingsModule)
